export default __webpack_public_path__ + "static/media/639.59102e9d.png";